var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _path8, _g5, _path9, _g6, _path0, _g7, _path1, _g8, _path10, _path11, _g9, _path12, _path13, _g0, _path14, _path15, _g1, _path16, _g10, _path17, _g11, _g12, _path18, _path19, _g13, _path20, _path21, _g14, _path22, _g15, _path23, _g16, _g17, _path24, _path25, _g18, _path26, _path27, _g19, _path28, _g20, _path29, _g21, _path30, _g22, _g23, _path31, _g24, _g25, _path32, _g26, _path33, _path34, _g27, _path35, _path36, _g28, _path37, _g29, _path38, _path39, _g30, _path40, _path41, _g31, _path42, _g32, _path43, _path44, _g33, _path45, _g34, _path46, _g35, _g36, _path47, _path48, _g37, _path49, _g38, _path50, _g39, _g40, _path51, _path52, _g41, _path53, _g42, _path54, _g43, _path55, _g44, _path56, _g45, _path57, _g46, _path58, _g47, _path59, _g48, _path60, _g49, _path61, _g50, _path62, _g51, _path63, _g52, _path64, _path65, _g53, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _g54, _path84, _path85, _g55, _path86, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiraffeAngry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_182337)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.03 320C214.17 320 258.06 314.044 258.06 306.698C258.06 299.352 214.17 293.396 160.03 293.396C105.889 293.396 62 299.352 62 306.698C62 314.044 105.889 320 160.03 320Z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.363 236.775C219.363 236.775 230.727 224.672 227.138 205.318C225.104 194.234 217.987 180.153 198.369 164.874L186.766 179.853C201.06 190.938 207.041 200.705 208.537 208.734C210.271 218.081 205.307 224.072 205.307 224.072L219.363 236.775Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 164,
    width: 42,
    height: 73
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.363 236.775C219.363 236.775 230.727 224.672 227.138 205.318C225.104 194.234 217.987 180.153 198.369 164.874L186.766 179.853C201.06 190.938 207.041 200.705 208.537 208.734C210.271 218.081 205.307 224.072 205.307 224.072L219.363 236.775Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.821 237.493C246.097 193.215 228.094 158.163 201.598 148.756L182.578 162.117C196.693 165.712 237.245 198.307 217.687 233.719C223.668 237.553 225.821 237.493 225.821 237.493Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 164,
    width: 42,
    height: 73
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.363 236.775C219.363 236.775 230.727 224.672 227.138 205.318C225.104 194.234 217.987 180.153 198.369 164.874L186.766 179.853C201.06 190.938 207.041 200.705 208.537 208.734C210.271 218.081 205.307 224.072 205.307 224.072L219.363 236.775Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.339 194.893C210.21 194.893 212.483 197.229 212.483 200.045C212.483 202.862 210.15 205.198 207.339 205.198C204.468 205.198 202.195 202.862 202.195 200.045C202.195 197.169 204.468 194.893 207.339 194.893Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 164,
    width: 42,
    height: 73
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219.363 236.775C219.363 236.775 230.727 224.672 227.138 205.318C225.104 194.234 217.987 180.153 198.369 164.874L186.766 179.853C201.06 190.938 207.041 200.705 208.537 208.734C210.271 218.081 205.307 224.072 205.307 224.072L219.363 236.775Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.026 182.25C199.325 179.973 201.299 178.415 203.452 178.655C205.606 178.955 207.101 181.052 206.742 183.269C206.443 185.546 204.469 187.104 202.316 186.864C200.223 186.624 198.727 184.527 199.026 182.25Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 164,
    width: 42,
    height: 73
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M219.363 236.775C219.363 236.775 230.727 224.672 227.138 205.318C225.104 194.234 217.987 180.153 198.369 164.874L186.766 179.853C201.06 190.938 207.041 200.705 208.537 208.734C210.271 218.081 205.307 224.072 205.307 224.072L219.363 236.775Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.655 212.628C215.895 210.95 217.45 209.752 219.065 209.991C220.739 210.231 221.876 211.789 221.696 213.467C221.457 215.144 219.902 216.343 218.287 216.103C216.612 215.863 215.416 214.306 215.655 212.628Z",
    fill: "#673620"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.355 236.775C101.355 236.775 89.9909 224.672 93.5796 205.318C95.6131 194.234 102.731 180.153 122.349 164.874L133.952 179.853C119.657 190.938 113.676 200.705 112.181 208.734C110.446 218.081 115.411 224.072 115.411 224.072L101.355 236.775Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 164,
    width: 42,
    height: 73
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.355 236.775C101.355 236.775 89.9909 224.672 93.5796 205.318C95.6131 194.234 102.731 180.153 122.349 164.874L133.952 179.853C119.657 190.938 113.676 200.705 112.181 208.734C110.446 218.081 115.411 224.072 115.411 224.072L101.355 236.775Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8969 237.493C74.621 193.215 92.6241 158.163 119.12 148.756L138.14 162.117C124.025 165.712 83.473 198.307 103.031 233.719C97.0501 237.553 94.8969 237.493 94.8969 237.493Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 164,
    width: 42,
    height: 73
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.355 236.775C101.355 236.775 89.9909 224.672 93.5796 205.318C95.6131 194.234 102.731 180.153 122.349 164.874L133.952 179.853C119.657 190.938 113.676 200.705 112.181 208.734C110.446 218.081 115.411 224.072 115.411 224.072L101.355 236.775Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.378 194.893C110.507 194.893 108.234 197.229 108.234 200.045C108.234 202.862 110.567 205.198 113.378 205.198C116.249 205.198 118.522 202.862 118.522 200.045C118.522 197.169 116.189 194.893 113.378 194.893Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 164,
    width: 42,
    height: 73
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M101.355 236.775C101.355 236.775 89.9909 224.672 93.5796 205.318C95.6131 194.234 102.731 180.153 122.349 164.874L133.952 179.853C119.657 190.938 113.676 200.705 112.181 208.734C110.446 218.081 115.411 224.072 115.411 224.072L101.355 236.775Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.632 182.25C121.333 179.973 119.359 178.415 117.206 178.655C115.053 178.955 113.558 181.052 113.917 183.269C114.216 185.546 116.189 187.104 118.343 186.864C120.496 186.624 121.991 184.527 121.632 182.25Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 164,
    width: 42,
    height: 73
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M101.355 236.775C101.355 236.775 89.9909 224.672 93.5796 205.318C95.6131 194.234 102.731 180.153 122.349 164.874L133.952 179.853C119.657 190.938 113.676 200.705 112.181 208.734C110.446 218.081 115.411 224.072 115.411 224.072L101.355 236.775Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.005 212.628C104.766 210.95 103.21 209.752 101.596 209.991C99.9209 210.231 98.7845 211.789 98.9639 213.467C99.2032 215.144 100.758 216.343 102.373 216.103C104.108 215.863 105.244 214.306 105.005 212.628Z",
    fill: "#673620"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M224.328 254.33C218.885 255.169 211.349 253.012 204.411 247.799C199.148 243.785 194.243 237.973 190.834 230.184L184.016 233.599C188.322 242.586 194.303 249.117 200.643 253.551C209.375 259.603 218.706 261.58 225.285 260.322L224.328 254.33Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 230,
    width: 42,
    height: 31
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M224.328 254.33C218.885 255.169 211.349 253.012 204.411 247.799C199.148 243.785 194.243 237.973 190.834 230.184L184.016 233.599C188.322 242.586 194.303 249.117 200.643 253.551C209.375 259.603 218.706 261.58 225.285 260.322L224.328 254.33Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.485 237.613C189.099 240.369 191.731 242.886 193.944 245.103C200.105 251.215 207.222 255.648 215.416 257.686C217.629 258.225 219.902 258.884 222.235 258.944C222.414 258.944 222.893 259.543 223.012 259.663C223.73 260.262 224.448 260.741 225.225 261.161C227.498 262.419 229.95 263.018 232.522 262.898C238.025 262.719 242.57 259.543 246.159 255.349C247.355 253.971 248.492 252.533 249.628 251.035C250.047 250.436 250.525 249.777 250.944 249.177C251.004 249.117 251.303 248.638 251.422 248.758C251.662 249.057 251.123 250.076 251.004 250.376C250.346 252.113 249.568 253.731 248.671 255.349C244.963 261.94 239.101 266.913 231.625 267.572C228.275 267.872 224.866 267.332 221.816 265.954C220.201 265.235 218.766 263.917 217.151 263.318C214.28 262.239 211.17 262.119 208.299 260.981C199.267 257.326 190.714 250.316 185.75 241.568L187.485 237.613Z",
    fill: "#CE8710"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M224.627 263.797C220.022 262.719 214.938 256.128 220.799 251.994C228.515 246.481 236.051 250.795 239.699 248.159C239.34 250.136 237.187 252.413 232.343 254.091C231.864 254.271 234.316 254.031 234.735 253.971C237.247 253.552 239.281 252.114 241.015 250.376C244.963 246.481 246.578 247.14 246.518 247.2C243.109 251.514 241.733 255.828 240.357 257.446C234.974 263.857 230.01 265.116 224.627 263.797Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 218,
    y: 247,
    width: 29,
    height: 18
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M224.627 263.797C220.022 262.719 214.938 256.128 220.799 251.994C228.515 246.481 236.051 250.795 239.699 248.159C239.34 250.136 237.187 252.413 232.343 254.091C231.864 254.271 234.316 254.031 234.735 253.971C237.247 253.552 239.281 252.114 241.015 250.376C244.963 246.481 246.578 247.14 246.518 247.2C243.109 251.514 241.733 255.828 240.357 257.446C234.974 263.857 230.01 265.116 224.627 263.797Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.183 237.854C195.2 240.13 197.054 242.347 198.609 244.265C202.916 249.597 208.239 253.672 214.639 256.128C216.373 256.787 218.168 257.506 219.962 257.746C220.082 257.746 220.44 258.285 220.5 258.345C220.979 258.885 221.577 259.304 222.115 259.723C223.79 260.922 225.764 261.641 227.797 261.82C232.223 262.24 236.23 260.263 239.52 257.387C240.597 256.428 241.673 255.469 242.69 254.451C243.109 254.031 243.527 253.552 243.946 253.132C244.006 253.073 244.305 252.773 244.365 252.833C244.484 253.073 243.946 253.851 243.886 254.031C243.228 255.289 242.391 256.488 241.494 257.626C237.905 262.3 232.642 265.535 226.601 265.296C223.909 265.176 221.218 264.457 218.885 263.079C217.629 262.36 216.672 261.221 215.356 260.562C213.143 259.424 210.691 259.064 208.478 257.866C201.6 254.151 195.38 247.92 192.27 240.61L194.183 237.854Z",
    fill: "#301007"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M148.904 306.578C148.904 306.578 148.247 269.19 154.826 250.136L115.53 236.595C107.396 260.382 107.336 306.938 107.336 306.938L148.904 306.578Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 236,
    width: 48,
    height: 71
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M148.904 306.578C148.904 306.578 148.247 269.19 154.826 250.136L115.53 236.595C107.396 260.382 107.336 306.938 107.336 306.938L148.904 306.578Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.3 306.878C112.539 294.535 113.795 260.382 120.434 241.148L153.988 252.712C154.228 251.814 154.527 250.975 154.826 250.136L115.53 236.595C107.396 260.382 107.336 306.938 107.336 306.938L112.3 306.878Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 236,
    width: 48,
    height: 71
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M148.904 306.578C148.904 306.578 148.247 269.19 154.826 250.136L115.53 236.595C107.396 260.382 107.336 306.938 107.336 306.938L148.904 306.578Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.054 280.934C131.379 280.694 129.824 281.832 129.585 283.51C129.346 285.188 130.482 286.746 132.157 286.985C133.832 287.225 135.387 286.087 135.626 284.409C135.925 282.731 134.729 281.173 133.054 280.934ZM118.58 264.396C114.692 264.396 111.582 267.512 111.582 271.407C111.582 275.301 114.752 278.417 118.58 278.417C122.468 278.417 125.578 275.301 125.578 271.407C125.578 267.512 122.468 264.396 118.58 264.396Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 264,
    width: 25,
    height: 24
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 264,
    width: 25,
    height: 24
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M133.054 280.934C131.379 280.694 129.824 281.832 129.585 283.51C129.346 285.188 130.482 286.746 132.157 286.985C133.832 287.225 135.387 286.087 135.626 284.409C135.925 282.731 134.729 281.173 133.054 280.934ZM118.58 264.396C114.692 264.396 111.582 267.512 111.582 271.407C111.582 275.301 114.752 278.417 118.58 278.417C122.468 278.417 125.578 275.301 125.578 271.407C125.578 267.512 122.468 264.396 118.58 264.396Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.904 306.578C148.904 306.578 148.247 269.19 154.826 250.136L115.53 236.595C107.396 260.382 107.336 306.938 107.336 306.938L148.904 306.578Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.3 306.878C112.539 294.535 113.795 260.382 120.434 241.148L153.988 252.712C154.228 251.814 154.527 250.975 154.826 250.136L115.53 236.595C107.396 260.382 107.336 306.938 107.336 306.938L112.3 306.878Z",
    fill: "#C3A088"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M107.935 307.717C107.158 307.717 106.44 307.297 106.021 306.638C105.602 305.979 105.602 305.14 105.961 304.421C109.67 297.89 119.598 293.097 129.706 293.097C140.113 293.097 147.59 298.13 150.341 304.96C150.58 305.559 150.52 306.278 150.162 306.818C149.803 307.357 149.205 307.657 148.547 307.657C140.532 307.717 116.608 307.717 107.935 307.717Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 293,
    width: 46,
    height: 15
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.935 307.717C107.158 307.717 106.44 307.297 106.021 306.638C105.602 305.979 105.602 305.14 105.961 304.421C109.67 297.89 119.598 293.097 129.706 293.097C140.113 293.097 147.59 298.13 150.341 304.96C150.58 305.559 150.52 306.278 150.162 306.818C149.803 307.357 149.205 307.657 148.547 307.657C140.532 307.717 116.608 307.717 107.935 307.717Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.348 302.384C104.886 303.223 105.843 303.762 106.92 303.762C117.087 303.762 140.832 303.762 150.103 303.702C150.94 303.702 151.718 303.342 152.196 302.743C152.495 303.163 152.735 303.582 152.974 304.002C153.393 304.78 153.393 305.739 152.914 306.518C152.436 307.297 151.598 307.776 150.641 307.776C141.131 307.836 116.609 307.836 106.202 307.836C105.065 307.836 103.989 307.177 103.51 306.218C102.972 305.2 103.092 304.061 103.809 303.163C103.989 302.803 104.168 302.623 104.348 302.384Z",
    fill: "#301007"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M171.093 306.578C171.093 306.578 171.751 269.19 165.172 250.136L204.468 236.595C212.602 260.382 212.662 306.938 212.662 306.938L171.093 306.578Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 236,
    width: 48,
    height: 71
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M171.093 306.578C171.093 306.578 171.751 269.19 165.172 250.136L204.468 236.595C212.602 260.382 212.662 306.938 212.662 306.938L171.093 306.578Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.697 306.878C207.458 294.535 206.202 260.382 199.563 241.148L166.009 252.712C165.77 251.814 165.471 250.975 165.172 250.136L204.468 236.595C212.602 260.382 212.662 306.938 212.662 306.938L207.697 306.878Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 236,
    width: 48,
    height: 71
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M171.093 306.578C171.093 306.578 171.751 269.19 165.172 250.136L204.468 236.595C212.602 260.382 212.662 306.938 212.662 306.938L171.093 306.578Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.627 280.934C187.302 280.694 188.857 281.832 189.096 283.51C189.335 285.188 188.199 286.746 186.524 286.985C184.85 287.225 183.294 286.087 183.055 284.409C182.816 282.731 183.952 281.173 185.627 280.934ZM200.101 264.396C203.989 264.396 207.099 267.512 207.099 271.407C207.099 275.301 203.989 278.417 200.101 278.417C196.214 278.417 193.103 275.301 193.103 271.407C193.103 267.512 196.214 264.396 200.101 264.396Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 264,
    width: 25,
    height: 24
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 264,
    width: 25,
    height: 24
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M185.627 280.934C187.302 280.694 188.857 281.832 189.096 283.51C189.335 285.188 188.199 286.746 186.524 286.985C184.85 287.225 183.294 286.087 183.055 284.409C182.816 282.731 183.952 281.173 185.627 280.934ZM200.101 264.396C203.989 264.396 207.099 267.512 207.099 271.407C207.099 275.301 203.989 278.417 200.101 278.417C196.214 278.417 193.103 275.301 193.103 271.407C193.103 267.512 196.214 264.396 200.101 264.396Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.093 306.578C171.093 306.578 171.751 269.19 165.172 250.136L204.468 236.595C212.602 260.382 212.662 306.938 212.662 306.938L171.093 306.578Z",
    fill: "white"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.697 306.878C207.458 294.535 206.202 260.382 199.563 241.148L166.009 252.712C165.77 251.814 165.471 250.975 165.172 250.136L204.468 236.595C212.602 260.382 212.662 306.938 212.662 306.938L207.697 306.878Z",
    fill: "#301007"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M212.065 307.717C212.843 307.717 213.56 307.297 213.979 306.638C214.398 305.979 214.398 305.14 214.039 304.421C210.331 297.89 200.402 293.097 190.294 293.097C179.887 293.097 172.41 298.13 169.659 304.96C169.42 305.559 169.48 306.278 169.839 306.818C170.197 307.357 170.796 307.657 171.453 307.657C179.528 307.717 203.392 307.717 212.065 307.717Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 293,
    width: 46,
    height: 15
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M212.065 307.717C212.843 307.717 213.56 307.297 213.979 306.638C214.398 305.979 214.398 305.14 214.039 304.421C210.331 297.89 200.402 293.097 190.294 293.097C179.887 293.097 172.41 298.13 169.659 304.96C169.42 305.559 169.48 306.278 169.839 306.818C170.197 307.357 170.796 307.657 171.453 307.657C179.528 307.717 203.392 307.717 212.065 307.717Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.652 302.384C215.114 303.223 214.157 303.762 213.08 303.762C202.912 303.762 179.167 303.762 169.897 303.702C169.059 303.702 168.282 303.342 167.803 302.743C167.504 303.163 167.265 303.582 167.026 304.002C166.607 304.78 166.607 305.739 167.085 306.518C167.564 307.297 168.401 307.776 169.358 307.776C178.868 307.836 203.391 307.836 213.798 307.836C214.934 307.836 216.011 307.177 216.489 306.218C217.027 305.2 216.908 304.061 216.19 303.163C216.071 302.803 215.831 302.623 215.652 302.384Z",
    fill: "#301007"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M193.226 157.024H126.776C119.12 182.909 113.199 208.613 113.199 226.109C113.199 256.907 134.073 272.964 159.911 272.964C185.75 272.964 206.803 256.967 206.803 226.109C206.803 208.673 200.882 182.969 193.226 157.024Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 157,
    width: 94,
    height: 116
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M193.226 157.024H126.776C119.12 182.909 113.199 208.613 113.199 226.109C113.199 256.907 134.073 272.964 159.911 272.964C185.75 272.964 206.803 256.967 206.803 226.109C206.803 208.673 200.882 182.969 193.226 157.024Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.518 157.024H126.776C119.12 182.909 113.199 208.613 113.199 226.109C113.199 239.77 117.326 252.293 124.204 262C120.317 253.252 118.104 243.186 118.104 232.46C118.104 215.084 123.726 184.047 132.518 157.024Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 157,
    width: 94,
    height: 116
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M193.226 157.024H126.776C119.12 182.909 113.199 208.613 113.199 226.109C113.199 256.907 134.073 272.964 159.911 272.964C185.75 272.964 206.803 256.967 206.803 226.109C206.803 208.673 200.882 182.969 193.226 157.024Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.484 157.024H193.226C200.882 182.909 206.803 208.613 206.803 226.109C206.803 239.77 202.676 252.293 195.798 262C199.686 253.252 201.899 243.186 201.899 232.46C201.899 215.084 196.277 184.047 187.484 157.024Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 157,
    width: 94,
    height: 116
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M193.226 157.024H126.776C119.12 182.909 113.199 208.613 113.199 226.109C113.199 256.907 134.073 272.964 159.911 272.964C185.75 272.964 206.803 256.967 206.803 226.109C206.803 208.673 200.882 182.969 193.226 157.024Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.04 240.19C129.408 240.19 127.255 242.407 127.255 245.163C127.255 247.919 129.408 250.136 132.04 250.136C134.671 250.136 136.825 247.919 136.825 245.163C136.825 242.407 134.671 240.19 132.04 240.19ZM188.98 240.489C191.552 240.489 193.585 242.407 193.585 244.803C193.585 247.2 191.492 249.117 188.98 249.117C186.408 249.117 184.374 247.2 184.374 244.803C184.314 242.467 186.408 240.489 188.98 240.489ZM201.002 223.173C203.873 223.173 206.145 225.51 206.145 228.326C206.145 231.142 203.813 233.479 201.002 233.479C198.131 233.479 195.858 231.142 195.858 228.326C195.798 225.45 198.131 223.173 201.002 223.173ZM117.566 221.675C114.695 221.675 112.422 223.952 112.422 226.828C112.422 229.644 114.754 231.981 117.566 231.981C120.437 231.981 122.709 229.704 122.709 226.828C122.709 223.952 120.377 221.675 117.566 221.675ZM190.415 212.448C192.09 212.448 193.466 213.826 193.466 215.504C193.466 217.181 192.09 218.56 190.415 218.56C188.74 218.56 187.365 217.181 187.365 215.504C187.365 213.826 188.681 212.448 190.415 212.448ZM128.451 209.991C126.776 209.991 125.401 211.369 125.401 213.047C125.401 214.725 126.776 216.103 128.451 216.103C130.126 216.103 131.502 214.725 131.502 213.047C131.502 211.31 130.126 209.991 128.451 209.991ZM199.447 188.241C203.334 188.241 206.444 191.357 206.444 195.252C206.444 199.086 203.334 202.262 199.447 202.262C195.559 202.262 192.449 199.146 192.449 195.252C192.449 191.357 195.559 188.241 199.447 188.241ZM120.137 188.241C116.25 188.241 113.14 191.357 113.14 195.252C113.14 199.086 116.25 202.262 120.137 202.262C124.025 202.262 127.135 199.146 127.135 195.252C127.135 191.357 124.025 188.241 120.137 188.241ZM186.767 178.774C188.441 178.774 189.817 180.152 189.817 181.83C189.817 183.508 188.441 184.886 186.767 184.886C185.092 184.886 183.716 183.508 183.716 181.83C183.716 180.152 185.092 178.774 186.767 178.774ZM132.817 178.774C131.143 178.774 129.767 180.152 129.767 181.83C129.767 183.508 131.143 184.886 132.817 184.886C134.492 184.886 135.868 183.508 135.868 181.83C135.868 180.152 134.492 178.774 132.817 178.774Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 178,
    width: 94,
    height: 73
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 178,
    width: 95,
    height: 73
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M132.04 240.19C129.408 240.19 127.255 242.407 127.255 245.163C127.255 247.919 129.408 250.136 132.04 250.136C134.671 250.136 136.825 247.919 136.825 245.163C136.825 242.407 134.671 240.19 132.04 240.19ZM188.98 240.489C191.552 240.489 193.585 242.407 193.585 244.803C193.585 247.2 191.492 249.117 188.98 249.117C186.408 249.117 184.374 247.2 184.374 244.803C184.314 242.467 186.408 240.489 188.98 240.489ZM201.002 223.173C203.873 223.173 206.145 225.51 206.145 228.326C206.145 231.142 203.813 233.479 201.002 233.479C198.131 233.479 195.858 231.142 195.858 228.326C195.798 225.45 198.131 223.173 201.002 223.173ZM117.566 221.675C114.695 221.675 112.422 223.952 112.422 226.828C112.422 229.644 114.754 231.981 117.566 231.981C120.437 231.981 122.709 229.704 122.709 226.828C122.709 223.952 120.377 221.675 117.566 221.675ZM190.415 212.448C192.09 212.448 193.466 213.826 193.466 215.504C193.466 217.181 192.09 218.56 190.415 218.56C188.74 218.56 187.365 217.181 187.365 215.504C187.365 213.826 188.681 212.448 190.415 212.448ZM128.451 209.991C126.776 209.991 125.401 211.369 125.401 213.047C125.401 214.725 126.776 216.103 128.451 216.103C130.126 216.103 131.502 214.725 131.502 213.047C131.502 211.31 130.126 209.991 128.451 209.991ZM199.447 188.241C203.334 188.241 206.444 191.357 206.444 195.252C206.444 199.086 203.334 202.262 199.447 202.262C195.559 202.262 192.449 199.146 192.449 195.252C192.449 191.357 195.559 188.241 199.447 188.241ZM120.137 188.241C116.25 188.241 113.14 191.357 113.14 195.252C113.14 199.086 116.25 202.262 120.137 202.262C124.025 202.262 127.135 199.146 127.135 195.252C127.135 191.357 124.025 188.241 120.137 188.241ZM186.767 178.774C188.441 178.774 189.817 180.152 189.817 181.83C189.817 183.508 188.441 184.886 186.767 184.886C185.092 184.886 183.716 183.508 183.716 181.83C183.716 180.152 185.092 178.774 186.767 178.774ZM132.817 178.774C131.143 178.774 129.767 180.152 129.767 181.83C129.767 183.508 131.143 184.886 132.817 184.886C134.492 184.886 135.868 183.508 135.868 181.83C135.868 180.152 134.492 178.774 132.817 178.774Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.226 157.024H126.776C119.12 182.909 113.199 208.613 113.199 226.109C113.199 256.907 134.073 272.964 159.911 272.964C185.75 272.964 206.803 256.967 206.803 226.109C206.803 208.673 200.882 182.969 193.226 157.024Z",
    fill: "white"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.484 157.024H193.226C200.882 182.909 206.803 208.613 206.803 226.109C206.803 239.77 202.676 252.293 195.798 262C199.686 253.252 201.899 243.186 201.899 232.46C201.899 215.084 196.277 184.047 187.484 157.024Z",
    fill: "#301007"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 178,
    width: 94,
    height: 73
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 178,
    width: 95,
    height: 73
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M132.04 240.19C129.408 240.19 127.255 242.407 127.255 245.163C127.255 247.919 129.408 250.136 132.04 250.136C134.671 250.136 136.825 247.919 136.825 245.163C136.825 242.407 134.671 240.19 132.04 240.19ZM188.98 240.489C191.552 240.489 193.585 242.407 193.585 244.803C193.585 247.2 191.492 249.117 188.98 249.117C186.408 249.117 184.374 247.2 184.374 244.803C184.314 242.467 186.408 240.489 188.98 240.489ZM201.002 223.173C203.873 223.173 206.145 225.51 206.145 228.326C206.145 231.142 203.813 233.479 201.002 233.479C198.131 233.479 195.858 231.142 195.858 228.326C195.798 225.45 198.131 223.173 201.002 223.173ZM117.566 221.675C114.695 221.675 112.422 223.952 112.422 226.828C112.422 229.644 114.754 231.981 117.566 231.981C120.437 231.981 122.709 229.704 122.709 226.828C122.709 223.952 120.377 221.675 117.566 221.675ZM190.415 212.448C192.09 212.448 193.466 213.826 193.466 215.504C193.466 217.181 192.09 218.56 190.415 218.56C188.74 218.56 187.365 217.181 187.365 215.504C187.365 213.826 188.681 212.448 190.415 212.448ZM128.451 209.991C126.776 209.991 125.401 211.369 125.401 213.047C125.401 214.725 126.776 216.103 128.451 216.103C130.126 216.103 131.502 214.725 131.502 213.047C131.502 211.31 130.126 209.991 128.451 209.991ZM199.447 188.241C203.334 188.241 206.444 191.357 206.444 195.252C206.444 199.086 203.334 202.262 199.447 202.262C195.559 202.262 192.449 199.146 192.449 195.252C192.449 191.357 195.559 188.241 199.447 188.241ZM120.137 188.241C116.25 188.241 113.14 191.357 113.14 195.252C113.14 199.086 116.25 202.262 120.137 202.262C124.025 202.262 127.135 199.146 127.135 195.252C127.135 191.357 124.025 188.241 120.137 188.241ZM186.767 178.774C188.441 178.774 189.817 180.152 189.817 181.83C189.817 183.508 188.441 184.886 186.767 184.886C185.092 184.886 183.716 183.508 183.716 181.83C183.716 180.152 185.092 178.774 186.767 178.774ZM132.817 178.774C131.143 178.774 129.767 180.152 129.767 181.83C129.767 183.508 131.143 184.886 132.817 184.886C134.492 184.886 135.868 183.508 135.868 181.83C135.868 180.152 134.492 178.774 132.817 178.774Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.226 157.024H126.776C119.12 182.909 113.199 208.613 113.199 226.109C113.199 256.907 134.073 272.964 159.911 272.964C185.75 272.964 206.803 256.967 206.803 226.109C206.803 208.673 200.882 182.969 193.226 157.024Z",
    fill: "white"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.518 157.024H126.776C119.12 182.909 113.199 208.613 113.199 226.109C113.199 239.77 117.326 252.293 124.204 262C120.317 253.252 118.104 243.186 118.104 232.46C118.104 215.084 123.726 184.047 132.518 157.024Z",
    fill: "#9D6E51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 157,
    width: 94,
    height: 116
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M193.226 157.024H126.776C119.12 182.909 113.199 208.613 113.199 226.109C113.199 256.907 134.073 272.964 159.911 272.964C185.75 272.964 206.803 256.967 206.803 226.109C206.803 208.673 200.882 182.969 193.226 157.024Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.025 143.124C178.75 162.537 185.808 202.023 185.808 215.384C185.808 234.857 174.982 247.021 160.029 247.021C145.136 247.021 133.832 234.857 133.832 215.384C133.832 202.023 140.83 162.537 145.555 143.124H174.025Z",
    fill: "#EFD36F"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M140.769 12.0244L133.293 14.0017L139.872 38.9872L147.349 37.0099L140.769 12.0244Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 12,
    width: 15,
    height: 27
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M140.769 12.0244L133.293 14.0017L139.872 38.9872L147.349 37.0099L140.769 12.0244Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.254 14.7208L135.568 12.5039L142.207 37.5494L133.893 39.7064L127.254 14.7208Z",
    fill: "#CE8710"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M136.285 1C141.13 1 145.077 4.95455 145.077 9.80785C145.077 14.6612 141.13 18.6157 136.285 18.6157C131.44 18.6157 127.493 14.6612 127.493 9.80785C127.433 4.95455 131.381 1 136.285 1Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 1,
    width: 19,
    height: 18
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M136.285 1C141.13 1 145.077 4.95455 145.077 9.80785C145.077 14.6612 141.13 18.6157 136.285 18.6157C131.44 18.6157 127.493 14.6612 127.493 9.80785C127.433 4.95455 131.381 1 136.285 1Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.268 3.5768C135.627 3.99622 134.789 5.25449 133.474 6.39292C132.158 7.53135 130.782 8.13052 130.423 7.77102C130.064 7.35159 130.902 6.09333 132.218 4.9549C133.533 3.75655 134.909 3.15738 135.268 3.5768Z",
    fill: "#C3A088"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 1,
    width: 19,
    height: 18
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M136.285 1C141.13 1 145.077 4.95455 145.077 9.80785C145.077 14.6612 141.13 18.6157 136.285 18.6157C131.44 18.6157 127.493 14.6612 127.493 9.80785C127.433 4.95455 131.381 1 136.285 1Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.821 5.25391C144.599 6.57209 145.077 8.12994 145.077 9.80763C145.077 14.6609 141.13 18.6155 136.285 18.6155C132.337 18.6155 128.988 15.9791 127.852 12.444C129.407 15.0204 132.218 16.6981 135.388 16.6981C140.232 16.6981 144.18 12.7436 144.18 7.89027C144.18 6.93159 144.06 6.09275 143.821 5.25391Z",
    fill: "#301007"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M179.228 12.0244L186.704 14.0017L180.125 38.9872L172.648 37.0099L179.228 12.0244Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 172,
    y: 12,
    width: 15,
    height: 27
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M179.228 12.0244L186.704 14.0017L180.125 38.9872L172.648 37.0099L179.228 12.0244Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.744 14.7208L184.431 12.5039L177.852 37.5494L186.165 39.7064L192.744 14.7208Z",
    fill: "#CE8710"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M183.777 1C178.932 1 174.984 4.95455 174.984 9.80785C174.984 14.6612 178.932 18.6157 183.777 18.6157C188.621 18.6157 192.569 14.6612 192.569 9.80785C192.569 4.95455 188.621 1 183.777 1Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 1,
    width: 19,
    height: 18
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M183.777 1C178.932 1 174.984 4.95455 174.984 9.80785C174.984 14.6612 178.932 18.6157 183.777 18.6157C188.621 18.6157 192.569 14.6612 192.569 9.80785C192.569 4.95455 188.621 1 183.777 1Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.732 3.5768C184.373 3.99622 185.21 5.25449 186.526 6.39292C187.842 7.53135 189.218 8.13052 189.576 7.77102C189.935 7.35159 189.098 6.09333 187.782 4.9549C186.466 3.75655 185.091 3.15738 184.732 3.5768Z",
    fill: "#C3A088"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 1,
    width: 19,
    height: 18
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M183.777 1C178.932 1 174.984 4.95455 174.984 9.80785C174.984 14.6612 178.932 18.6157 183.777 18.6157C188.621 18.6157 192.569 14.6612 192.569 9.80785C192.569 4.95455 188.621 1 183.777 1Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.182 5.25391C175.404 6.57209 174.926 8.12994 174.926 9.80763C174.926 14.6609 178.873 18.6155 183.718 18.6155C187.665 18.6155 191.015 15.9791 192.151 12.444C190.596 15.0204 187.785 16.6981 184.615 16.6981C179.77 16.6981 175.823 12.7436 175.823 7.89027C175.823 6.93159 175.943 6.09275 176.182 5.25391Z",
    fill: "#301007"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M185.212 42.223C185.152 42.7623 185.631 41.2044 185.87 40.7251C186.408 39.7065 187.066 38.7478 187.664 37.7892C189.459 35.0929 191.373 32.3966 193.406 29.8801C199.627 22.2706 207.641 16.3387 216.433 11.9648C218.886 10.7664 223.491 7.77056 226.183 9.80775C229.831 12.6239 226.661 23.2292 225.525 26.7044C221.637 38.3883 208 50.6115 194.423 50.8511L185.212 42.223Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 9,
    width: 43,
    height: 42
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M185.212 42.223C185.152 42.7623 185.631 41.2044 185.87 40.7251C186.408 39.7065 187.066 38.7478 187.664 37.7892C189.459 35.0929 191.373 32.3966 193.406 29.8801C199.627 22.2706 207.641 16.3387 216.433 11.9648C218.886 10.7664 223.491 7.77056 226.183 9.80775C229.831 12.6239 226.661 23.2292 225.525 26.7044C221.637 38.3883 208 50.6115 194.423 50.8511L185.212 42.223Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.629 5.73374C224.689 5.31432 225.167 6.39283 225.407 6.81225C225.825 7.53126 226.065 8.3701 226.304 9.14903C226.902 11.5457 227.261 14.1222 226.842 16.5189C225.526 23.8288 221.1 30.0602 216.076 35.3928C214.402 37.1903 212.667 38.868 210.813 40.4858C208.719 42.2833 206.566 44.0209 204.114 45.2792C203.636 45.5189 202.26 46.4176 201.662 46.2379C200.824 45.9982 199.808 44.0808 199.21 43.4817C196.877 41.1449 193.946 39.4672 190.896 38.2689C190.298 38.0292 188.503 37.1304 187.786 37.43C187.666 37.4899 189.999 39.8267 190.118 40.0065C191.614 41.6242 193.049 43.3019 194.365 45.0994C196.578 48.0354 198.552 51.1511 200.047 54.5065C200.346 55.1656 201.064 58.1614 201.841 58.461C202.619 58.7606 204.832 57.023 205.37 56.7234C209.078 54.5065 212.547 52.0499 215.777 49.2937C224.45 41.9238 230.251 31.3184 231.747 20.054C232.524 14.242 231.687 7.53126 227.62 2.97754L224.629 5.73374Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 9,
    width: 43,
    height: 42
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M185.212 42.223C185.152 42.7623 185.631 41.2044 185.87 40.7251C186.408 39.7065 187.066 38.7478 187.664 37.7892C189.459 35.0929 191.373 32.3966 193.406 29.8801C199.627 22.2706 207.641 16.3387 216.433 11.9648C218.886 10.7664 223.491 7.77056 226.183 9.80775C229.831 12.6239 226.661 23.2292 225.525 26.7044C221.637 38.3883 208 50.6115 194.423 50.8511L185.212 42.223Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.187 48.9333C187.067 48.8135 188.443 46.8961 188.563 46.7763C190.178 44.4395 191.972 42.2825 193.826 40.1854C198.91 34.3734 204.891 28.6812 211.65 25.1461C212.547 24.6668 213.504 24.1874 214.521 23.8279C216.494 23.049 219.784 22.5098 219.066 25.8651C218.947 26.4044 218.767 26.8837 218.588 27.423C217.152 31.018 214.64 34.2536 212.009 36.9498C209.556 39.4664 206.626 41.4436 203.695 43.2412C199.388 45.8775 194.783 47.4354 190.178 49.4127L187.187 48.9333Z",
    fill: "#F6DCBB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 187,
    y: 23,
    width: 33,
    height: 27
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 187,
    y: 23,
    width: 33,
    height: 27
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M187.183 48.9343C187.064 48.8145 188.439 46.8971 188.559 46.7773C190.174 44.4405 191.968 42.2835 193.822 40.1864C198.906 34.3744 204.887 28.6822 211.646 25.1471C212.543 24.6678 213.5 24.1884 214.517 23.8289C216.49 23.05 219.78 22.5107 219.062 25.8661C218.943 26.4054 218.763 26.8847 218.584 27.424C217.148 31.019 214.636 34.2545 212.005 36.9508C209.552 39.4673 206.622 41.4446 203.691 43.2421C199.385 45.8785 194.779 47.4364 190.174 49.4136L187.183 48.9343Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.208 42.224C185.148 42.7633 185.627 41.2054 185.866 40.7261C186.404 39.7075 187.062 38.7488 187.66 37.7901C189.455 35.0939 191.369 32.3976 193.402 29.881C199.623 22.2715 207.637 16.3397 216.429 11.9658C218.882 10.7674 223.487 7.77154 226.179 9.80873C229.827 12.6248 226.657 23.2302 225.521 26.7054C221.633 38.3893 207.996 50.6124 194.419 50.8521L185.208 42.224Z",
    fill: "white"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.625 5.73374C224.685 5.31432 225.164 6.39283 225.403 6.81225C225.821 7.53126 226.061 8.3701 226.3 9.14903C226.898 11.5457 227.257 14.1222 226.838 16.5189C225.522 23.8288 221.096 30.0602 216.072 35.3928C214.398 37.1903 212.663 38.868 210.809 40.4858C208.716 42.2833 206.562 44.0209 204.11 45.2792C203.632 45.5189 202.256 46.4176 201.658 46.2379C200.821 45.9982 199.804 44.0808 199.206 43.4817C196.873 41.1449 193.942 39.4672 190.892 38.2689C190.294 38.0292 188.5 37.1304 187.782 37.43C187.662 37.4899 189.995 39.8267 190.114 40.0065C191.61 41.6242 193.045 43.3019 194.361 45.0994C196.574 48.0354 198.548 51.1511 200.043 54.5065C200.342 55.1656 201.06 58.1614 201.837 58.461C202.615 58.7606 204.828 57.023 205.366 56.7234C209.074 54.5065 212.543 52.0499 215.773 49.2937C224.446 41.9238 230.247 31.3184 231.743 20.054C232.52 14.242 231.683 7.53126 227.616 2.97754L224.625 5.73374Z",
    fill: "#EEC18F"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M134.79 42.2227C134.85 42.7619 134.371 41.2041 134.132 40.7248C133.594 39.7062 132.936 38.7475 132.338 37.7888C130.543 35.0925 128.629 32.3962 126.596 29.8797C120.375 22.3301 112.301 16.3384 103.509 12.0243C101.057 10.826 96.4511 7.83013 93.7596 9.86732C90.1112 12.6834 93.2812 23.2888 94.4176 26.764C98.3053 38.4479 111.942 50.671 125.519 50.9107L134.79 42.2227Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 9,
    width: 43,
    height: 42
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M134.79 42.2227C134.85 42.7619 134.371 41.2041 134.132 40.7248C133.594 39.7062 132.936 38.7475 132.338 37.7888C130.543 35.0925 128.629 32.3962 126.596 29.8797C120.375 22.3301 112.301 16.3384 103.509 12.0243C101.057 10.826 96.4511 7.83013 93.7596 9.86732C90.1112 12.6834 93.2812 23.2888 94.4176 26.764C98.3053 38.4479 111.942 50.671 125.519 50.9107L134.79 42.2227Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3739 5.73283C95.3141 5.3134 94.8356 6.39192 94.5964 6.81134C94.1777 7.53035 93.9384 8.36919 93.6992 9.14811C93.1011 11.5448 92.7422 14.1213 93.1609 16.5179C94.4767 23.8279 98.9027 30.0593 103.927 35.3919C105.602 37.1894 107.336 38.8671 109.19 40.4849C111.284 42.2824 113.437 44.02 115.889 45.2783C116.367 45.5179 117.743 46.4167 118.341 46.237C119.179 45.9973 120.195 44.0799 120.793 43.4808C123.126 41.144 126.057 39.4663 129.107 38.2679C129.705 38.0283 131.5 37.1295 132.217 37.4291C132.337 37.489 130.004 39.8258 129.885 40.0056C128.389 41.6233 126.954 43.301 125.638 45.0985C123.425 48.0345 121.451 51.1502 119.956 54.5056C119.657 55.1646 118.939 58.1605 118.162 58.4601C117.384 58.7597 115.171 57.0221 114.633 56.7225C110.925 54.5056 107.456 52.0489 104.226 49.2927C95.6132 41.7432 89.7517 31.1977 88.3162 19.8733C87.5387 14.0613 88.376 7.35059 92.4432 2.79688L95.3739 5.73283Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 9,
    width: 43,
    height: 42
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M134.79 42.2227C134.85 42.7619 134.371 41.2041 134.132 40.7248C133.594 39.7062 132.936 38.7475 132.338 37.7888C130.543 35.0925 128.629 32.3962 126.596 29.8797C120.375 22.3301 112.301 16.3384 103.509 12.0243C101.057 10.826 96.4511 7.83013 93.7596 9.86732C90.1112 12.6834 93.2812 23.2888 94.4176 26.764C98.3053 38.4479 111.942 50.671 125.519 50.9107L134.79 42.2227Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.816 48.9333C132.935 48.8135 131.56 46.8961 131.44 46.7763C129.825 44.4395 128.031 42.2825 126.177 40.1854C121.093 34.3734 115.112 28.6812 108.353 25.1461C107.456 24.6668 106.499 24.1874 105.482 23.8279C103.508 23.049 100.219 22.5098 100.937 25.8651C101.056 26.4044 101.236 26.8837 101.415 27.423C102.851 31.018 105.363 34.2536 107.994 36.9498C110.446 39.4664 113.377 41.4436 116.308 43.2412C120.614 45.8775 125.22 47.4354 129.825 49.4127L132.816 48.9333Z",
    fill: "#F6DCBB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 23,
    width: 33,
    height: 27
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask41_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 23,
    width: 33,
    height: 27
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M132.816 48.9343C132.935 48.8145 131.56 46.8971 131.44 46.7773C129.825 44.4405 128.031 42.2835 126.177 40.1864C121.093 34.3744 115.112 28.6822 108.353 25.1471C107.456 24.6678 106.499 24.1884 105.482 23.8289C103.508 23.05 100.219 22.5107 100.937 25.8661C101.056 26.4054 101.236 26.8847 101.415 27.424C102.851 31.019 105.363 34.2545 107.994 36.9508C110.446 39.4673 113.377 41.4446 116.308 43.2421C120.614 45.8785 125.22 47.4364 129.825 49.4136L132.816 48.9343Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.79 42.2237C134.85 42.7629 134.371 41.2051 134.132 40.7257C133.594 39.7071 132.936 38.7485 132.338 37.7898C130.543 35.0935 128.629 32.3972 126.596 29.8807C120.375 22.3311 112.301 16.3394 103.509 12.0253C101.057 10.827 96.4511 7.83111 93.7596 9.8683C90.1112 12.6844 93.2812 23.2898 94.4176 26.765C98.3053 38.4489 111.942 50.672 125.519 50.9117L134.79 42.2237Z",
    fill: "white"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3739 5.7338C95.3141 5.31438 94.8356 6.39289 94.5964 6.81231C94.1777 7.53132 93.9384 8.37017 93.6992 9.14909C93.1011 11.5458 92.7422 14.1222 93.1609 16.5189C94.4767 23.8288 98.9027 30.0602 103.927 35.3929C105.602 37.1904 107.336 38.8681 109.19 40.4859C111.284 42.2834 113.437 44.021 115.889 45.2793C116.367 45.5189 117.743 46.4177 118.341 46.2379C119.179 45.9983 120.195 44.0809 120.793 43.4817C123.126 41.145 126.057 39.4673 129.107 38.2689C129.705 38.0293 131.5 37.1305 132.217 37.4301C132.337 37.49 130.004 39.8268 129.885 40.0065C128.389 41.6243 126.954 43.302 125.638 45.0995C123.425 48.0355 121.451 51.1512 119.956 54.5065C119.657 55.1656 118.939 58.1615 118.162 58.4611C117.384 58.7607 115.171 57.0231 114.633 56.7235C110.925 54.5065 107.456 52.0499 104.226 49.2937C95.6132 41.7441 89.7517 31.1987 88.3162 19.8743C87.5387 14.0623 88.376 7.35157 92.4432 2.79785L95.3739 5.7338Z",
    fill: "#EEC18F"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M159.731 176.617C137.362 176.917 88.1378 156.845 97.5281 106.574C110.806 34.9727 137.123 29.9996 160.03 29.4004H160.569C183.297 30.0595 209.315 35.512 222.533 106.574C231.863 157.084 182.22 177.097 160.03 176.617H159.731Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 29,
    width: 128,
    height: 148
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M159.731 176.617C137.362 176.917 88.1378 156.845 97.5281 106.574C110.806 34.9727 137.123 29.9996 160.03 29.4004H160.569C183.297 30.0595 209.315 35.512 222.533 106.574C231.863 157.084 182.22 177.097 160.03 176.617H159.731Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.852 58.8193C143.883 58.8193 151.18 66.2491 151.18 75.4164C151.18 84.5838 143.883 92.0135 134.852 92.0135C125.82 92.0135 118.523 84.5838 118.523 75.4164C118.523 66.2491 125.88 58.8193 134.852 58.8193Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 29,
    width: 128,
    height: 148
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M159.731 176.617C137.362 176.917 88.1378 156.845 97.5281 106.574C110.806 34.9727 137.123 29.9996 160.03 29.4004H160.569C183.297 30.0595 209.315 35.512 222.533 106.574C231.863 157.084 182.22 177.097 160.03 176.617H159.731Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.852 64.4521C141.431 64.4521 146.754 69.8447 146.754 76.4955C146.754 83.1464 141.431 88.5389 134.852 88.5389C128.272 88.5389 122.949 83.1464 122.949 76.4955C122.949 69.8447 128.332 64.4521 134.852 64.4521Z",
    fill: "#301007"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 29,
    width: 128,
    height: 148
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M159.731 176.617C137.362 176.917 88.1378 156.845 97.5281 106.574C110.806 34.9727 137.123 29.9996 160.03 29.4004H160.569C183.297 30.0595 209.315 35.512 222.533 106.574C231.863 157.084 182.22 177.097 160.03 176.617H159.731Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.303 68.0468C138.2 67.3877 139.995 68.3464 141.37 70.2038C142.746 72.0613 143.165 74.0984 142.267 74.7575C141.37 75.4166 139.576 74.4579 138.2 72.6005C136.825 70.7431 136.466 68.7059 137.303 68.0468Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 29,
    width: 128,
    height: 148
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M159.731 176.617C137.362 176.917 88.1378 156.845 97.5281 106.574C110.806 34.9727 137.123 29.9996 160.03 29.4004H160.569C183.297 30.0595 209.315 35.512 222.533 106.574C231.863 157.084 182.22 177.097 160.03 176.617H159.731Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.564 76.7354C143.581 76.7354 144.358 77.5742 144.358 78.5329C144.358 79.5515 143.581 80.3304 142.564 80.3304C141.547 80.3304 140.77 79.4915 140.77 78.5329C140.77 77.5742 141.607 76.7354 142.564 76.7354Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 29,
    width: 128,
    height: 148
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M159.731 176.617C137.362 176.917 88.1378 156.845 97.5281 106.574C110.806 34.9727 137.123 29.9996 160.03 29.4004H160.569C183.297 30.0595 209.315 35.512 222.533 106.574C231.863 157.084 182.22 177.097 160.03 176.617H159.731Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.153 58.8193C194.184 58.8193 201.481 66.2491 201.481 75.4164C201.481 84.5838 194.184 92.0135 185.153 92.0135C176.121 92.0135 168.824 84.5838 168.824 75.4164C168.824 66.2491 176.121 58.8193 185.153 58.8193Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 29,
    width: 128,
    height: 148
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M159.731 176.617C137.362 176.917 88.1378 156.845 97.5281 106.574C110.806 34.9727 137.123 29.9996 160.03 29.4004H160.569C183.297 30.0595 209.315 35.512 222.533 106.574C231.863 157.084 182.22 177.097 160.03 176.617H159.731Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.152 64.4521C191.732 64.4521 197.055 69.8447 197.055 76.4955C197.055 83.1464 191.732 88.5389 185.152 88.5389C178.573 88.5389 173.25 83.1464 173.25 76.4955C173.25 69.8447 178.573 64.4521 185.152 64.4521Z",
    fill: "#301007"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 29,
    width: 128,
    height: 148
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M159.731 176.617C137.362 176.917 88.1378 156.845 97.5281 106.574C110.806 34.9727 137.123 29.9996 160.03 29.4004H160.569C183.297 30.0595 209.315 35.512 222.533 106.574C231.863 157.084 182.22 177.097 160.03 176.617H159.731Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.604 68.0468C188.501 67.3877 190.295 68.3464 191.671 70.2038C193.047 72.0613 193.465 74.0984 192.568 74.7575C191.671 75.4166 189.877 74.4579 188.501 72.6005C187.125 70.7431 186.767 68.7059 187.604 68.0468Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 29,
    width: 128,
    height: 148
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M159.731 176.617C137.362 176.917 88.1378 156.845 97.5281 106.574C110.806 34.9727 137.123 29.9996 160.03 29.4004H160.569C183.297 30.0595 209.315 35.512 222.533 106.574C231.863 157.084 182.22 177.097 160.03 176.617H159.731Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.865 76.7354C193.881 76.7354 194.659 77.5742 194.659 78.5329C194.659 79.5515 193.881 80.3304 192.865 80.3304C191.848 80.3304 191.07 79.4915 191.07 78.5329C191.07 77.5742 191.908 76.7354 192.865 76.7354Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 29,
    width: 128,
    height: 148
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M159.731 176.617C137.362 176.917 88.1378 156.845 97.5281 106.574C110.806 34.9727 137.123 29.9996 160.03 29.4004H160.569C183.297 30.0595 209.315 35.512 222.533 106.574C231.863 157.084 182.22 177.097 160.03 176.617H159.731Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.067 70.8627C196.756 66.9082 203.156 60.1375 201.362 55.7636C199.627 51.3896 190.356 51.0301 180.727 54.9846C171.097 58.9392 164.698 65.7098 166.432 70.0838C168.167 74.4578 177.437 74.8173 187.067 70.8627Z",
    fill: "#E4B637"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 29,
    width: 128,
    height: 148
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M159.731 176.617C137.362 176.917 88.1378 156.845 97.5281 106.574C110.806 34.9727 137.123 29.9996 160.03 29.4004H160.569C183.297 30.0595 209.315 35.512 222.533 106.574C231.863 157.084 182.22 177.097 160.03 176.617H159.731Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.09 70.8627C125.461 66.9082 119.061 60.1375 120.795 55.7636C122.53 51.3896 131.801 51.0301 141.43 54.9846C151.06 58.9392 157.459 65.7098 155.725 70.0838C153.99 74.4578 144.779 74.8173 135.09 70.8627Z",
    fill: "#E4B637"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 29,
    width: 128,
    height: 148
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M159.731 176.617C137.362 176.917 88.1378 156.845 97.5281 106.574C110.806 34.9727 137.123 29.9996 160.03 29.4004H160.569C183.297 30.0595 209.315 35.512 222.533 106.574C231.863 157.084 182.22 177.097 160.03 176.617H159.731Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.719 58.1604C126.415 32.3959 144.06 29.8195 159.969 29.46H160.508C176.298 29.9393 193.703 32.6955 207.22 58.1604C193.463 35.2719 176.238 32.6955 160.508 32.2761H159.969C144.119 32.6356 126.655 34.9724 112.719 58.1604Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 29,
    width: 128,
    height: 148
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M159.731 176.617C137.362 176.917 88.1378 156.845 97.5281 106.574C110.806 34.9727 137.123 29.9996 160.03 29.4004H160.569C183.297 30.0595 209.315 35.512 222.533 106.574C231.863 157.084 182.22 177.097 160.03 176.617H159.731Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.645 60.1982C107.219 70.4441 103.271 83.8057 100.101 101.182C99.6826 103.339 99.4434 105.436 99.2639 107.473C98.4864 109.57 98.0079 111.907 98.0079 114.543C98.0079 153.549 125.76 170.626 159.972 170.626C194.184 170.626 221.936 153.549 221.936 114.543C221.936 111.967 221.517 109.63 220.68 107.533C220.5 105.496 220.201 103.339 219.842 101.182C216.673 83.8057 212.785 70.504 208.299 60.1982C213.802 71.223 218.646 86.2024 222.414 106.574C222.833 108.791 223.132 110.948 223.312 113.045C224.149 115.202 224.568 117.539 224.568 120.235C224.568 160.14 195.619 177.576 159.912 177.576C124.205 177.576 95.3164 160.14 95.3164 120.235C95.3164 117.599 95.7949 115.202 96.6322 113.045C96.8117 110.948 97.1107 108.791 97.5294 106.634C101.297 86.2024 106.142 71.223 111.645 60.1982Z",
    fill: "#CE8710"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M160.391 93.752C180.846 93.752 224.687 94.2313 224.687 120.235C224.687 160.14 195.739 177.576 160.032 177.576C124.325 177.576 95.3164 160.14 95.3164 120.235C95.3164 93.8119 139.935 93.752 160.391 93.752Z",
    fill: "#F6DCBB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 93,
    width: 130,
    height: 85
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M160.391 93.752C180.846 93.752 224.687 94.2313 224.687 120.235C224.687 160.14 195.739 177.576 160.032 177.576C124.325 177.576 95.3164 160.14 95.3164 120.235C95.3164 93.8119 139.935 93.752 160.391 93.752Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.645 60.1982C107.219 70.4441 103.271 83.8057 100.101 101.182C99.6826 103.339 99.4434 105.436 99.2639 107.473C98.4864 109.57 98.0079 111.907 98.0079 114.543C98.0079 153.549 125.76 170.626 159.972 170.626C194.184 170.626 221.936 153.549 221.936 114.543C221.936 111.967 221.517 109.63 220.68 107.533C220.5 105.496 220.201 103.339 219.842 101.182C216.673 83.8057 212.785 70.504 208.299 60.1982C213.802 71.223 218.646 86.2024 222.414 106.574C222.833 108.791 223.132 110.948 223.312 113.045C224.149 115.202 224.568 117.539 224.568 120.235C224.568 160.14 195.619 177.576 159.912 177.576C124.205 177.576 95.3164 160.14 95.3164 120.235C95.3164 117.599 95.7949 115.202 96.6322 113.045C96.8117 110.948 97.1107 108.791 97.5294 106.634C101.297 86.2024 106.142 71.223 111.645 60.1982Z",
    fill: "#EEC18F"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.992 37.4893C142.445 37.4893 144.418 39.4665 144.418 41.9231C144.418 44.3798 142.445 46.357 139.992 46.357C137.54 46.357 135.566 44.3798 135.566 41.9231C135.566 39.4665 137.54 37.4893 139.992 37.4893Z",
    fill: "#673620"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.559 46.3574C166.011 46.3574 167.985 48.3347 167.985 50.7913C167.985 53.2479 166.011 55.2252 163.559 55.2252C161.107 55.2252 159.133 53.2479 159.133 50.7913C159.133 48.3347 161.107 46.3574 163.559 46.3574Z",
    fill: "#673620"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.203 37.4893C183.237 37.4893 184.852 39.107 184.852 41.1442C184.852 43.1814 183.237 44.7992 181.203 44.7992C179.17 44.7992 177.555 43.1814 177.555 41.1442C177.555 39.107 179.17 37.4893 181.203 37.4893Z",
    fill: "#673620"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.273 34.0743C156.024 33.7148 158.596 35.752 158.955 38.628C159.314 41.5041 157.4 44.1404 154.648 44.4999C151.897 44.8595 149.325 42.8223 148.966 39.9462C148.548 37.0702 150.521 34.4338 153.273 34.0743Z",
    fill: "#673620"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.598 54.2666C153.093 54.2666 154.289 55.4649 154.289 56.9629C154.289 58.4608 153.093 59.6592 151.598 59.6592C150.102 59.6592 148.906 58.4608 148.906 56.9629C148.906 55.5249 150.102 54.2666 151.598 54.2666Z",
    fill: "#673620"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.504 47.8557C150.341 47.9755 150.999 48.6945 150.879 49.5933C150.76 50.4321 150.042 51.0912 149.145 50.9714C148.248 50.8516 147.649 50.1325 147.769 49.2338C147.889 48.3949 148.666 47.7958 149.504 47.8557Z",
    fill: "#673620"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.332 42.1631C172.17 42.1631 172.888 42.8821 172.888 43.7209C172.888 44.5598 172.17 45.2788 171.332 45.2788C170.495 45.2788 169.777 44.5598 169.777 43.7209C169.777 42.8222 170.495 42.1631 171.332 42.1631Z",
    fill: "#673620"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.821 56.6631C169.658 56.6631 170.376 57.3821 170.376 58.2209C170.376 59.0598 169.658 59.7788 168.821 59.7788C167.983 59.7788 167.266 59.0598 167.266 58.2209C167.266 57.3821 167.983 56.6631 168.821 56.6631Z",
    fill: "#673620"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.207 33.8945C168.702 33.8945 169.899 35.0929 169.899 36.5908C169.899 38.0887 168.702 39.2871 167.207 39.2871C165.712 39.2871 164.516 38.0887 164.516 36.5908C164.516 35.0929 165.712 33.8945 167.207 33.8945Z",
    fill: "#673620"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.291 50.1924C141.547 50.1924 142.504 51.211 142.504 52.4093C142.504 53.6676 141.487 54.6263 140.291 54.6263C139.035 54.6263 138.078 53.6077 138.078 52.4093C138.078 51.1511 139.095 50.1924 140.291 50.1924Z",
    fill: "#673620"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.031 60.4385C162.065 60.4385 163.68 62.0562 163.68 64.0934C163.68 66.1306 162.065 67.7484 160.031 67.7484C157.998 67.7484 156.383 66.1306 156.383 64.0934C156.383 62.0562 157.998 60.4385 160.031 60.4385Z",
    fill: "#673620"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.716 48.9941C178.152 48.9941 179.288 50.1326 179.288 51.5706C179.288 53.0086 178.152 54.147 176.716 54.147C175.281 54.147 174.145 53.0086 174.145 51.5706C174.145 50.1326 175.341 48.9941 176.716 48.9941Z",
    fill: "#673620"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.666 105.976C122.887 105.976 127.911 108.252 127.911 111.009C127.911 113.765 122.887 116.042 116.666 116.042C110.446 116.042 105.422 113.765 105.422 111.009C105.482 108.193 110.506 105.976 116.666 105.976Z",
    fill: "#E96565"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.334 105.676C209.555 105.676 214.579 107.953 214.579 110.709C214.579 113.465 209.555 115.742 203.334 115.742C197.114 115.742 192.09 113.465 192.09 110.709C192.09 107.893 197.114 105.676 203.334 105.676Z",
    fill: "#E96565"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.018 104.418C146.633 103.759 149.026 105.436 150.401 108.133C151.777 110.829 151.597 113.585 150.042 114.244C148.427 114.903 146.035 113.226 144.659 110.529C143.284 107.833 143.463 105.077 145.018 104.418Z",
    fill: "#301007"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.984 104.418C173.369 103.759 170.976 105.436 169.601 108.133C168.225 110.829 168.405 113.585 169.96 114.244C171.574 114.903 173.967 113.226 175.343 110.529C176.718 107.833 176.599 105.077 174.984 104.418Z",
    fill: "#301007"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M221.872 233.479C217.985 248.818 199.025 253.551 196.393 240.909C195.496 236.475 199.503 230.423 203.271 227.727C201.596 228.206 197.111 228.206 198.307 225.27C198.785 224.192 201.896 222.095 206.979 221.615C212.901 223.473 220.557 228.685 221.872 233.479Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 221,
    width: 26,
    height: 28
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M221.872 233.479C217.985 248.818 199.025 253.551 196.393 240.909C195.496 236.475 199.503 230.423 203.271 227.727C201.596 228.206 197.111 228.206 198.307 225.27C198.785 224.192 201.896 222.095 206.979 221.615C212.901 223.473 220.557 228.685 221.872 233.479Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.273 222.274C221.153 225.45 217.325 237.434 214.574 239.471C210.507 244.624 203.569 247.919 195.195 240.31C196.87 251.934 207.337 254.75 207.337 254.75L228.091 233.898L221.273 222.274Z",
    fill: "#301007"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M99.082 233.479C102.97 248.818 121.93 253.551 124.561 240.909C125.459 236.475 121.451 230.423 117.683 227.727C119.358 228.206 123.844 228.206 122.647 225.27C122.169 224.192 119.059 222.095 113.975 221.615C107.994 223.473 100.338 228.685 99.082 233.479Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_197_182337",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 221,
    width: 26,
    height: 28
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M99.082 233.479C102.97 248.818 121.93 253.551 124.561 240.909C125.459 236.475 121.451 230.423 117.683 227.727C119.358 228.206 123.844 228.206 122.647 225.27C122.169 224.192 119.059 222.095 113.975 221.615C107.994 223.473 100.338 228.685 99.082 233.479Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_197_182337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6817 222.274C99.8013 225.45 103.629 237.434 106.381 239.471C110.448 244.624 117.386 247.919 125.759 240.31C124.085 251.934 113.618 254.75 113.618 254.75L92.8633 233.898L99.6817 222.274Z",
    fill: "#301007"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.76 148.277C143.76 148.277 146.63 147.438 151.236 146.899C152.731 146.719 154.406 146.599 156.26 146.479C157.576 146.42 158.951 146.36 160.447 146.36C161.763 146.36 163.198 146.3 164.634 146.36C166.847 146.42 169.179 146.599 171.572 146.959C173.785 147.318 176.117 147.738 178.51 148.517C178.749 148.636 179.048 148.517 179.168 148.217C179.287 147.977 179.168 147.678 178.868 147.558C175.34 145.82 171.871 144.622 168.521 143.843C165.949 143.304 163.497 143.004 161.164 142.944C160.148 142.944 159.131 142.944 158.174 143.064C156.619 143.184 155.124 143.424 153.748 143.723C152.612 143.963 151.535 144.203 150.518 144.502C145.973 145.88 143.341 147.378 143.341 147.378C143.102 147.498 142.982 147.738 143.102 147.977C143.221 148.277 143.52 148.337 143.76 148.277Z",
    fill: "#301007"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_182337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 319,
    fill: "white",
    transform: "translate(62 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiraffeAngry);
export default __webpack_public_path__ + "static/media/giraffe_angry.89ca5bc0c0d5be9810339b78b0fa2add.svg";
export { ForwardRef as ReactComponent };